import styled from 'styled-components';
import { ArrowLeftStroke, MessageStroke, MenuStroke } from 'assets/icons';
import { Link } from 'react-router-dom';
import CommonsLogo from 'components/CommonsLogo';

export type NavbarColor = 'light' | 'dark' | 'birch';

const Container = styled.div`
  border-bottom: 1px solid rgba(22, 14, 8, 0.1);
  color: ${({ theme }) => theme.colors.textColors.primaryDark};
  height: 68px;
  ${({ color, theme }) => {
    if (color === 'dark') {
      return `
        background: ${theme.colors.neutralColors.charcoal};
        color: ${theme.colors.textColors.primaryLight};
      `;
    }
    if (color === 'light') {
      return `background: ${theme.colors.neutralColors.white};`;
    }
    if (color === 'birch') {
      return `background: ${theme.colors.brandColors.birchLight};`;
    }
  }}
  ${({ theme }) => theme.breakPoints.desktop} {
    height: 80px;
  }
`;

const Wrapper = styled.div`
  ${({ theme }) => `
    ${theme.breakPoints.desktop} {
      max-width: ${theme.containerWidth};
    }
  `}
  padding: 0 24px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
`;

const TempWrapper = styled.div`
  ${({ theme }) => `
    ${theme.breakPoints.desktop} {
      max-width: ${theme.containerWidth};
    }
  `}
  padding: 0 24px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
`;

const StyledButton = styled(Link)`
  background: transparent;
  border: none;
  cursor: pointer;
`;

const StyledAnchor = styled.a`
  background: transparent;
  border: none;
  cursor: pointer;
`;

export type NavBarProps = {
  color: NavbarColor;
};

export type SimpleNavBarProps = {
  color: NavbarColor;
  to: string;
};

export function SimpleNavBar({ color, to }: SimpleNavBarProps) {
  return (
    <Container color={color}>
      <Wrapper>
        <StyledButton to={to}>
          <ArrowLeftStroke color={color === 'dark' ? 'white' : 'black'} />
        </StyledButton>
      </Wrapper>
    </Container>
  );
}

export function SimpleNavBarExternal({ color, to }: SimpleNavBarProps) {
  return (
    <Container color={color}>
      <Wrapper>
        <StyledAnchor href={to}>
          <ArrowLeftStroke color={color === 'dark' ? 'white' : 'black'} />
        </StyledAnchor>
      </Wrapper>
    </Container>
  );
}

export default function NavBar({ color }: NavBarProps) {
  return (
    <Container color={color}>
      <TempWrapper>
        {/* <MenuStroke color={color === 'dark' ? 'white' : 'black'} /> */}
        <CommonsLogo color={color === 'dark' ? 'white' : 'black'} />
        {/* <MessageStroke color={color === 'dark' ? 'white' : 'black'} /> */}
      </TempWrapper>
    </Container>
  );
}
